import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GungBase } from 'gung-standard';
import { BehaviorSubject, Observable, catchError, first, of, tap } from 'rxjs';

export interface ColmecTirePolicy extends GungBase {
  customerId: string;
  customerName: string;
  tireType: string;
  tireAxle: string;
  season: string;
  measures: string;
  width: string;
  aspectRatio: string;
  diameter: string;
  supplierName: string;
  treadPattern: string;
  sortIndex?: number;
}

@Injectable({
  providedIn: 'root'
})
export class ColmecTirePolicyService {
  private tirePolicySubject: BehaviorSubject<ColmecTirePolicy[]>;

  constructor(protected http: HttpClient) {}

  public getTirePolicies(): Observable<ColmecTirePolicy[]> {
    if (!this.tirePolicySubject) {
      this.tirePolicySubject = new BehaviorSubject<ColmecTirePolicy[]>([]);
      this.getInternalAll();
    }
    return this.tirePolicySubject.asObservable();
  }

  public getInternalAll(): void {
    const url: string = 'json/colmec-tire-policy';
    const headers = {
      maxAge: '-1'
    };
    this.http
      .get<ColmecTirePolicy[]>(url, { headers })
      .pipe(first())
      .subscribe(data => this.tirePolicySubject.next(data));
  }

  public importTirePolicy(file: File): Observable<ColmecTirePolicy> {
    const url: string = 'json/colmec-tire-policy/excel/import';
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<ColmecTirePolicy>(url, formData).pipe(
      catchError(_ => of(undefined)),
      tap(_ => this.getInternalAll())
    );
  }
}
